import { FunctionsHttpError } from "@supabase/supabase-js";
import { supabase } from "../../lib/supabaseClient";

/** Supabase Auth calls. Errors are returned, not thrown; authService words them. */
export const authRepository = {
  signIn: (email: string, password: string) =>
    supabase.auth.signInWithPassword({ email, password }),
  signUp: (email: string, password: string) =>
    supabase.auth.signUp({
      email,
      password,
      options: { emailRedirectTo: window.location.origin },
    }),
  /** Redirects the browser to the provider; resolves only if that fails. */
  signInWithProvider: (provider: "google" | "facebook", redirectTo: string) =>
    supabase.auth.signInWithOAuth({ provider, options: { redirectTo } }),
  sendPasswordReset: (email: string, redirectTo: string) =>
    supabase.auth.resetPasswordForEmail(email, { redirectTo }),
  updatePassword: (password: string) => supabase.auth.updateUser({ password }),
  /** Resolves to an error sentence, or null once the account is gone. */
  async deleteAccount(): Promise<string | null> {
    const { error } = await supabase.functions.invoke("delete-account");
    if (!error) return null;
    if (error instanceof FunctionsHttpError) {
      const body = (await error.context.json().catch(() => null)) as {
        error?: string;
      } | null;
      if (body?.error) return body.error;
    }
    return "We couldn’t delete your account. Try again in a moment.";
  },
  signOut: () => supabase.auth.signOut({ scope: "local" }),
};
